module.exports = __webpack_public_path__ + "2a92cec1040e3337a33d19f9db6bf889.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Eesti-Display-Medium.ttf
// module id = 40
// module chunks = 0